import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './single-journey.css';
import { Table, Button } from "reactstrap";
import TollTipChildren from "../../../components/tolltip-children/TollTipChildren";
import Ballon from "../../../components/ballon/Ballon";
import JourneyEdit from "../../../components/journey-edit/JourneyEdit";



class SingleJourney extends React.Component {
    columns = [
        "Data da Jornada",
        "Inicio Jornada",
        "Tempo de Descanso",
        "Intervalo de Refeição",
        "Tempo de Espera",
        "Fim da Jornada",
        "Controle de Horas",
        "Auditoria",
        "",
        ""
    ]

    legendTable = [
        { label: 'Alterado ', color: 'orangered' },
        { label: 'Atestado / Férias / Folga ', color: '#4682B4' },
        { label: 'Feriado / Final de Semana', color: 'darksalmon' },
        { label: 'Original', color: 'var(--txt-color)' }
    ]


    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            table: {},
            alert: { msg: 'Selecione um Motorista para começar', type: '' },
            loading: false,
            filter: {
                startPeriod: "",
                endPeriod: "",
                idDrivers: [],
            }
        }
    }




    componentDidMount() {
        // this.getJourney(this.state.filter)
    }

    getJourney = data => {
        console.log(data)
        this.setState({ loading: true, table: [], alert: { msg: '', type: '' } });
        axios({
            method: !data ? 'get' : 'post',
            url: `${url}/v1/telemetria/admin/journey/list/byDriver/${this.props.token}`,
            data
        }).then(d => {
            var msg = !d.data.table ? 'Não encontramos dados para os filtros selecionados.' : ''
            console.log(d)
            this.setState({
                loading: false,
                table: d.data.table,
                driver: d.data.driver,
                // filter: d.data.reportFilter,
                alert: { msg, type: '' }
            })
        }).catch(e => {
            console.log(e.response)
            var errorMsg = e.response.data.errorMessage
            this.setState({ loading: false })
            errorMsg.forEach(d => {
                if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
            })
        })
    };

    exportJourney = body => {
        this.setState({ loading: true });
        axios
            .request({
                url: `${url}/v1/telemetria/admin/journey/export/byDriver/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    responseType: "blob"
                }
            })
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `journey_${body.startPeriod}_${body.endPeriod}.xlsx`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
                // console.log(data)
            })
            .catch(e => {
                console.log(e.response)
                this.props.validateToken(JSON.parse(localStorage.getItem("login")))
            })
    };

    renderRow = d => {
        if (d.mapUrl.length === 0) {
            return <span className={d.isChanged ? 'td-changed' : ''}>{d.show}</span>
        } else {
            return <a href={d.mapUrl} target='_blank' className={`link-table-journey ${d.isChanged ? 'td-changed' : ''}`} rel="noopener noreferrer">{d.show}</a>
        }
    }

    multRow = d => {
        if (d.length) {
            return d.map((d, i) => {
                return <div key={i}>{this.renderRow(d.start)}<span className='pipe-space'>|</span>{this.renderRow(d.end)}</div>
            })
        } else {
            return <span>-</span>
        }
    }

    checkJourney = (id, check) => {
        this.setState({ loading: true, toast: [] })

        axios.post(`${url}/v1/telemetria/admin/journey/check/${id}/${!check}/${this.props.token}`)
            .then(d => {
                this.getJourney(this.state.filter)
                store.addNotification({ ...this.props.bodyNotify, title: 'Validação Salva', type: 'success' });
            })
            .catch(e => {
                console.log(e.response)
                store.addNotification({ ...this.props.bodyNotify, title: 'A validação não pode ser salva', type: 'danger' });
                this.setState({ loading: false, })
            })
    }

    saveAdjustment = (d, method) => {
        this.getJourney(this.state.filter)
        let title = method ? `${d} Deletada.` : `${d} Alterada.`
        let type = method ? `warning` : `success`
        store.addNotification({ ...this.props.bodyNotify, title, type });

       
    }


    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.startPeriod} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                        value={this.state.filter.endPeriod}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        // isMulti
                        isClearable
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            
                            if (!i) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                
                                this.setState({ filter: { ...this.state.filter, idDrivers: [i.value] } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getJourney(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.rows ? (
                    <div style={{ marginRight: '5px' }}>
                        <div className='header-journey-control' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <span>{this.state.driver.driverName}</span>
                            <span>Matrícula: {this.state.driver.workerId}</span>
                            <span>Grupo: {this.state.driver.groupName}</span>
                        </div>
                        <div className='header-table-journey-control'>
                            <div className='export-button-container'>
                                <TollTipChildren text='Exportar Para Excel' id='export-to-excel'>
                                    <Button type="button" className='export-button' id='export-to-excel' onClick={() => this.exportJourney(this.state.filter)} />
                                </TollTipChildren>
                            </div>

                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>

                                {this.state.table.summaryHeader.map((d, i) => {
                                    return <p key={i}>{`${d.label}: ${d.value}`}</p>
                                })}

                                {this.legendTable.map((d, i) => {
                                    return (
                                        <div className='legend-container' key={i}>
                                            <div className='legend-iten' style={{ background: d.color }}></div>
                                            <p style={{ color: d.color }}>{d.label}</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>



                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                    {this.columns.map((d, i) => {
                                        return (
                                            <th key={i} style={{minWidth: '110px'}}>{d}</th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.table.rows.map((d, i) => {
                                    return (
                                        <tr key={i} className={`tr-table-pendencie tr-table-change-color ${d.justification ? 'tr-table-justification' : d.isHoliday || d.isWeekend ? 'tr-table-weekend' : undefined}`}>
                                            <td className='td-table-journey-control' style={{minWidth: '110px'}}>{d.dateJourney}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '110px'}}>{this.renderRow(d.journey.start)}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '110px'}}>{this.multRow(d.rest)}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '110px'}}>{this.multRow(d.food)}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '110px'}}>{this.multRow(d.wait)}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '110px'}}>{this.renderRow(d.journey.end)}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '110px'}}>{d.hourControl}</td>

                                            <td  style={{minWidth: '110px'}}><Ballon data={d.audit} id={i} nRows={this.state.table.rows.length} /></td>
                                            <td style={{minWidth: '110px'}}><Ballon data={{ edit: true }} id={i + 1000} nRows={this.state.table.rows.length} status={d.status}>
                                                <JourneyEdit data={d} driver={this.state.driver} token={this.props.token} _function={this.saveAdjustment} />
                                            </Ballon></td>
                                            <td style={{minWidth: '110px'}}>
                                                <TollTipChildren text='Validar Jornada' id={`check-journey-${i}`}>
                                                    <input
                                                        className='checkbox-round'
                                                        type="checkbox"
                                                        checked={d.check}
                                                        id={`check-journey-${i}`}
                                                        onChange={() => this.checkJourney(d.journeyId, d.check)}
                                                        disabled={this.state.loading || !d.journeyId.length}
                                                    />
                                                </TollTipChildren>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default SingleJourney